module.exports = __webpack_public_path__ + "static/img/image65.1c78402.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c34/image65.png
// module id = r8A2
// module chunks = 0